export const getRankingLink = event =>
	event.parent
		? `/events/${event.parent}/curriculumevents/${event.id}/ranking`
		: `/events/${event.id}/ranking`;
